<template>
  <v-container grid-list-md>
    <v-layout row wrap align-center>
      <v-flex>
        <v-text-field
          v-model="filters.search"
          label="Pesquisar atividade"
          prepend-inner-icon="mdi-magnify"
          solo
          single-line
          hide-details
        >
        </v-text-field>
      </v-flex>
      <v-flex style="flex: 0 auto">
        <v-btn color="primary" append to="/atividades" large>Voltar</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="md1">
        <v-text-field
          v-model="filters.ano"
          label="Ano"
          maxlength="4"
        ></v-text-field>
      </v-flex>
      <v-flex class="md2">
        <v-select
          v-model="filters.idTurma"
          :items="turmas ? turmas : []"
          label="Turma"
          :item-text="turmas_format"
          item-value="id"
        >
        </v-select>
      </v-flex>
      <v-flex class="md2">
        <v-select
          v-model="filters.idDisciplina"
          :disabled="disciplinas.length < 1"
          :items="disciplinas ? disciplinas : []"
          label="Disciplina"
          item-text="nome"
          item-value="id"
        ></v-select>
      </v-flex>

      <v-flex class="md2 align-items-baseline">
        <v-menu
          v-model="show_start_date"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          :disabled="data_enable"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="
                filters.inicio
                  ? moment(filters.inicio).format('DD/MM/YYYY')
                  : ''
              "
              label="De:"
              prepend-icon="event"
              readonly
              v-on="on"
              :error-messages="
                filters.fim && !filters.inicio
                  ? ['Informe a data de início']
                  : []
              "
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.inicio"
            @input="show_start_date = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex class="md2 align-bottom">
        <v-menu
          v-model="show_end_date"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="
                filters.fim ? moment(filters.fim).format('DD/MM/YYYY') : ''
              "
              label="Até:"
              prepend-icon="event"
              readonly
              v-on="on"
              :error-messages="
                filters.inicio && !filters.fim ? ['Informe a data de fim'] : []
              "
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.fim"
            @input="show_end_date = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex class="md1">
        <v-btn color="primary" @click="limpar">Limpar</v-btn>
      </v-flex>
    </v-layout>
    <v-divider />
    <v-data-table
      :headers="headers"
      :items="atividades.data"
      :search="filters.search"
      :options.sync="options"
      class="elevation-2"
      no-data-text="Não há atividades disponíveis"
      no-results-text="Nenhuma atividade encontrada"
      :loading="loading"
      :server-items-length="pagination.total"
      :footer-props="{ 'items-per-page-options': [5, 10, 20, 50] }"
    >
      <template #body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td
              style="cursor:pointer"
              @click="$router.push(`atividades/${item.id}`)"
            >
              {{ item.titulo }}
            </td>
            <td>
              {{
                item.tarefa_push &&
                  item.tarefa_push.length > 0 &&
                  item.tarefa_push[0].horario_data_envio &&
                  moment(item.tarefa_push[0].horario_data_envio).format(
                    'DD/MM/YYYY hh:mm'
                  )
              }}
            </td>
            <td>
              <v-chip
                small
                v-for="{ id, serie, nome } in item.turma.slice(0, 1)"
                :key="id"
                >{{ [serie.nome, nome, serie.nivel.nome].join(' ') }}</v-chip
              >
              <v-tooltip top v-if="item.turma.length > 1">
                <template #activator="{ on }">
                  <v-chip small v-on="on"
                    >+ {{ item.turma.length - 1 }} outras</v-chip
                  >
                </template>
                <span>
                  {{
                    item.turma
                      .slice(1)
                      .map(t =>
                        [t.serie.nome, t.nome, t.serie.nivel.nome].join(' ')
                      )
                      .join('; ')
                  }}
                </span>
              </v-tooltip>
            </td>
            <td>{{ item.disciplina.nome }}</td>
            <td>
              <v-chip
                v-if="item.status === 'P' && item.desativar === 'N'"
                color="warning"
                avatar
                small
              >
                <v-icon left small>mdi-timer-sand</v-icon>
                <span>Pendente</span>
              </v-chip>
              <v-chip
                v-if="item.status === 'A' && item.desativar === 'N'"
                color="primary"
                avatar
                small
              >
                <v-icon left small>mdi-clock-outline</v-icon>
                <span>Agendado</span>
              </v-chip>
              <v-chip
                v-if="item.status === 'E' && item.desativar === 'N'"
                color="success"
                avatar
                small
              >
                <v-icon left small>mdi-check</v-icon>
                <span>Publicado</span>
              </v-chip>
              <v-chip
                v-if="item.status === 'C' && item.desativar === 'N'"
                avatar
                small
              >
                <v-icon left small>mdi-file-document-box-check</v-icon>
                <span>Cadastrado</span>
              </v-chip>
              <v-chip
                v-if="item.status === 'D' || item.desativar === 'S'"
                dark
                avatar
                small
                class="mb-2"
              >
                <v-icon left small>mdi-eye-off</v-icon>
                <span>Desativado</span>
              </v-chip>
              <v-chip
                v-if="item.status === 'R' && item.desativar === 'N'"
                dark
                avatar
                small
              >
                <v-icon left small>mdi-file-document-box-remove</v-icon>
                <span>Reprovado</span>
              </v-chip>
            </td>
            <td>
              <v-btn icon append :to="`/atividades/${item.id}`">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
              <v-btn icon append :to="`/atividades/${item.id}/editar`">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <!-- <v-btn icon @click.stop="$refs.delete.request(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn> -->
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <confirm ref="delete" :confirm-fn="remove"
      >Deseja excluir esta atividade?</confirm
    >
  </v-container>
</template>

<script>
import { Atividade, Disciplina, Turma } from '../../../service'
import Confirm from '../../../components/Confirm'

export default {
  components: { Confirm },
  data() {
    return {
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      pagination: {
        current_page: 1,
        per_page: 0,
        total: 0
      },
      options: {},
      delay: 500,
      show_start_date: false,
      start_date: null,
      show_end_date: false,
      end_date: null,
      turmas: [],
      loading: false,
      data_enable: false,
      filters: {
        search: null,
        added_by: null,
        status: null,
        dataInicio: '',
        dataFim: '',
        ano: new Date().getFullYear(),
        idDisciplina: null,
        inicio: null,
        fim: null,
        idTurma: null
      },
      disciplinas: [],
      situacao: [
        { cod: 'P', nome: 'Pendente' },
        { cod: 'A', nome: 'Agendado' },
        { cod: 'E', nome: 'Publicado' },
        { cod: 'C', nome: 'Cadastrado' },
        { cod: 'D', nome: 'Desativado' },
        { cod: 'R', nome: 'Reprovado' }
      ],

      atividades: [],
      turmasLoaded: false,
      disciplinasLoaded: false,
      menu: false,
      menu2: false,
      headers: [
        {
          text: 'Título',
          value: 'titulo'
        },
        {
          text: 'Data/hora de publicação',
          align: 'left',
          value: 'horario_data_cadastro'
        },
        {
          text: 'Turma',
          value: 'turma.nome',
          sortable: false
        },
        {
          text: 'Disciplina',
          value: 'disciplina.nome',
          sortable: false
        },
        {
          text: 'Situação',
          value: 'status'
        },
        { text: 'Ação', value: 'name', sortable: false }
      ],
      expand: false
    }
  },
  watch: {
    filters: {
      deep: true,
      /* eslint-disable */
      handler() {
        clearTimeout(this.delay)
        this.delay = setTimeout(() => this.load(), 750)
      }
    },
    options: {
      deep: true,
      handler() {
        clearTimeout(this.delay)
        this.delay = setTimeout(() => this.load(), 750)
      }
    }
  },
  async created() {
    this.disciplinas = await Disciplina.findAll({ escola: this.escola })
    this.turmas = await Turma.findAll({ escola: this.escola, ano: this.filters.ano })
    this.disciplinasLoaded = this.disciplinas.length > 0
    this.turmasLoaded = this.turmas.length > 0
    this.options.sortBy.push('data')
    this.options.sortDesc = true
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      if (this.turmasLoaded && this.disciplinasLoaded) {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        this.atividades = await Atividade.atividadesAgendadas({
          ...this.filters,
          pagesize: this.options.itemsPerPage,
          page: this.options.page,
          order: this.options.sortBy ? this.options.sortBy[0] : '',
          dir: this.options.sortDesc == true ? 'DESC' : 'ASC',
          escola: this.escola
        }).finally(() => { this.loading = false })
        this.pagination.total = this.atividades.total
        this.pagination.current_page = this.atividades.current_page
        this.pagination.per_page = parseInt(this.atividades.per_page)
      }
    },
    async remove(id) {
      await Atividade.delete(id, { escola: this.escola })
      this.load()
    },

    limpar() {
      this.filters = {
        search: null,
        added_by: null,
        status: null,
        dataInicio: '',
        dataFim: '',
        ano: new Date().getFullYear(),
        idDisciplina: null,
        inicio: null,
        fim: null,
        idTurma: null
      }
    },
    turmas_format(turma) {
      return `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
    }
  }
}
</script>
<style scoped></style>
